import { PublicTokenApiClient } from '@fourthwall/services/dist/PublicTokenApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePublicTokenQuery = createQueryHook(PublicTokenApiClient.getPublicTokens, {
  queryKey: ['publicToken'],
})
